import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { Redirect } from 'react-router-dom'

const ConsultasSV = () => {
    return (
        <>
            {sessionStorage.login
            ?
                <div className="listado" id="menu">
                    <h2 className='tituloAccion'>Consultas</h2>
                    <TableContainer>
                        <Table sx={{minWidth: 500}} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell><a href="./Consultas-InformesSV">Informes</a></TableCell>
                                    <TableCell><a href="./Consultas-PlanillasSV">Planilla</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-PagosRealizados">Pagos Realizados</a></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            :
                <Redirect to='/login'/>
            }
        </>
    )
}

export default ConsultasSV